import React, { useEffect, useState, useMemo } from 'react'
import ClipLoader from "react-spinners/ClipLoader";
import { GetProfile, UpdateProfile } from '../api/customers'
import { Formik } from "formik";
import * as Yup from "yup";
import { Form, Alert, Row } from 'react-bootstrap'
import Select from 'react-select'
import countryList from 'react-select-country-list'
import US from 'iso3166-2-db/regions/US/en';

const schema = Yup.object().shape({
    EmailAddress: Yup.string().email("Not a Valid Email").required("Please enter an Email"),
    FirstName: Yup.string().min(2, "First name is too short.").max(50, "First name is too long").required("Please enter a first name"),
    LastName: Yup.string().required("Please enter a last name"),
    TelephoneNumber: Yup.string().required("Please enter a phone number"),

})

export default function MyProfile(props) {

    const [profile, setProfile] = useState(null);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const [country, setCountry] = useState("");
    const [state, setState] = useState("");
    const _countryList = useMemo(() => countryList().getData(), []);
    const _stateList = useMemo(() => {
        return US.map(item => {
            return {
                value: item.iso,
                label: item.name
            }
        }).sort((a, b) => a.label.localeCompare(b.label))
    })

    useEffect(async () => {
        let _profile = await GetProfile();
        setProfile(_profile);
        setCountry(_countryList.find(option => option.label === _profile.Country) || null);
        setState(_stateList.find(option => option.label === _profile.State) || null)

    }, [])
    return (
        <>

            {profile && <Formik
                validationSchema={schema}
                initialValues={profile}
                onSubmit={async (values) => {
                    setSubmitting(true);
                    setError(null);
                    setSuccess(null);
                    values.Country = country.label;
                    values.State = state?.label || "";
                    let _profile = await UpdateProfile(values);
                    if (_profile.Code === 0) {
                        setProfile(_profile);
                        setSuccess("Your profile has been updated successfully.")
                    } else {
                        setError("There was an issue updating your profile. Please try again.")
                    }
                    setSubmitting(false);

                }}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    setFieldValue,
                }) => (

                    <div className="myaccount-profile">
                        <h2>My Profile</h2>
                        <p>Your profile information helps us keep you up-to-date on renewals, billing, and support tickets.</p>


                        <div class="row profile-avatar">
                            <div class="col-md-3 profile-avatar-wrap">
                                <img src={values.avatar} />
                            </div>
                            <div class="col-md-9 profile-avatar-info">
                                <p>Profile avatars used on the MESCIUS web site are managed via <a href="https://gravatar.com/" target="_blank">Gravatar</a>. For more information on creating or updating your avatar, please visit the Gravatar <a href="https://en.gravatar.com/support/" target="_blank">support page</a>.</p>
                            </div>
                        </div>
                        <div className="form">
                            {error && <Alert transition={null} variant={'danger'}>{error}</Alert>}
                            {success && <Alert transition={null} variant={'success'}>{success}</Alert>}
                            <Form noValidate onSubmit={handleSubmit}>
                                <Row>
                                    <Form.Group controlId="FirstName" className={`col-md-5`}>
                                        <Form.Label>First Name *</Form.Label>
                                        <Form.Control value={values.FirstName} placeholder={`First Name`} name={"FirstName"} onChange={handleChange} onBlur={handleBlur} isInvalid={errors.FirstName}></Form.Control>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.FirstName}
                                        </Form.Control.Feedback>
                                    </Form.Group>


                                    <Form.Group controlId="LastName" className={`col-md-5`}>
                                        <Form.Label>Last Name *</Form.Label>
                                        <Form.Control value={values.LastName} placeholder={`Last Name`} name={"LastName"} onChange={handleChange} onBlur={handleBlur} isInvalid={errors.LastName}></Form.Control>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.LastName}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Row>
                                <Form.Group controlId="email" className={`col-md-10`}>
                                    <Form.Label>Email Address *</Form.Label>
                                    <Form.Control type="email" readOnly={true} value={values.EmailAddress} placeholder={`Email Address`} name={"EmailAddress"} onChange={handleChange} onBlur={handleBlur} isInvalid={errors.EmailAddress}></Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        {errors.EmailAddress && touched.EmailAddress && errors.EmailAddress}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group controlId="Title" className={`col-md-10`}>
                                    <Form.Label>Job Title</Form.Label>
                                    <Form.Control value={values.Title} placeholder={`Job Title`} name={"Title"}  onChange={handleChange} onBlur={handleBlur}></Form.Control>
                                </Form.Group>

                                <Form.Group className={`col-md-10`}>
                                    <Form.Label>Company *</Form.Label>
                                    <Form.Control readOnly={true} value={values.CompanyName} placeholder={`Company`} name={"CompanyName"}></Form.Control>
                                </Form.Group>

                                <Form.Row>
                                    <Form.Group controlId="TelephoneNumber" className={`col-md-10`}>
                                        <Form.Label>Phone *</Form.Label>
                                        <Form.Control value={values.TelephoneNumber} placeholder={`Phone Number`} name={"TelephoneNumber"} onChange={handleChange} onBlur={handleBlur} isInvalid={errors.TelephoneNumber}></Form.Control>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.TelephoneNumber}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Form.Row>
                                <Form.Row>
                                    <Form.Group controlId="Country" className={`col-md-10`}>
                                        <Form.Label>Country *</Form.Label>

                                        <Select options={_countryList} value={country} onChange={(value) => { value && setCountry(value); setState(null) }}></Select>

                                        <Form.Control.Feedback type="invalid">
                                            {errors.Country}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Form.Row>
                                <Form.Row>
                                    <Form.Group controlId="Address" className={`col-md-10`}>
                                        <Form.Label>Address</Form.Label>
                                        <Form.Control value={values.Address} name={"Address"} placeholder={`Address`} onChange={handleChange} onBlur={handleBlur} isInvalid={errors.Address}></Form.Control>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.Address1}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Form.Row>
                                <Form.Row>
                                    <Form.Group controlId="Address2" className={`col-md-10`}>
                                        <Form.Label>Address (cont.)</Form.Label>
                                        <Form.Control value={values.Address2} name={"Address2"} placeholder={`Address (cont.)`} onChange={handleChange} onBlur={handleBlur} isInvalid={errors.Address2}></Form.Control>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.Address2}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Form.Row>


                                {country?.value == "US" &&
                                    <Form.Row>
                                        <Form.Group controlId="State" className={`col-md-10`}>
                                            <Form.Label>State</Form.Label>

                                            <Select options={_stateList} value={state} onChange={(value) => { value && setState(value) }}></Select>
                                            <Form.Control.Feedback type="invalid">
                                                {errors.State}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Form.Row>
                                }
                                <Form.Row>
                                    <Form.Group controlId="City" className={`col-md-10`}>
                                        <Form.Label>City</Form.Label>
                                        <Form.Control value={values.City} name={"City"} placeholder={`City`} onChange={handleChange} onBlur={handleBlur} isInvalid={errors.City}></Form.Control>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.City}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Form.Row>
                                <Form.Row>
                                    <Form.Group controlId="PostalCode" className={`col-md-10`}>
                                        <Form.Label>Postal Code</Form.Label>
                                        <Form.Control value={values.PostalCode} placeholder={`Postal Code`} name={"PostalCode"} onChange={handleChange} onBlur={handleBlur} isInvalid={errors.PostalCode}></Form.Control>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.PostalCode}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Form.Row>


                                <button type="submit" class={`gc-btn primary-action`}>Update {submitting && <ClipLoader size={`18`} color={`#fff`} />}</button>
                            </Form>

                        </div>
                    </div>

                )}
            </Formik>
            }

            {!profile &&
                <ClipLoader size={`50px`} />
            }
        </>
    )
}

